import { Config } from "@/utils/config.utils";

export const findStoreById = async (
    StoresService: woosmap.map.StoresService,
    storeId: string
) => {
    const findStoreByIdQuery = [
        `user.locale:="${Config.getLocale()}"`,
        `user.storeId:="${storeId}"`
    ].join(" AND ");

    const storeSearchResponse = await StoresService.search({
        query: findStoreByIdQuery,
        storesByPage: 1
    });

    return storeSearchResponse?.features.find(
        (store) => store.properties.user_properties.storeId === storeId
    );
};
